<template>
    <div class="sprint-selector">
        <div class="dropdown">
            <a href="#" v-dropdown data-bs-popper-config='{"strategy":"fixed"}' aria-haspopup="true" aria-expanded="false" class="sprint">
                <p class="sprint-selected">{{sprint.title}}</p>
                <div class="row g-0 sprint-meta">
                    <div class="col">
                        <span class="muted">Start:</span> {{sprint.start_date | moment('DD/MM/YYYY')}}
                    </div>
                    <div class="col">
                        <span class="muted">End:</span> {{sprint.end_date | moment('DD/MM/YYYY')}}
                    </div>
                    <div class="col text-end">
                        <span class="status" v-bind:class="statusClass">{{sprint.status}}</span>
                    </div>
                </div>
            </a>

            <div class="dropdown-menu">
                <div class="sprint-search"><label class="visually-hidden">Search Sprints</label> <input type="text" placeholder="Search Sprints" class="form-control"></div>
                <ul class="sprint-selector-list">
                    <li v-for="sprint in sprints" :key="sprint.id">
                        <router-link tag="a" class="text-truncate" :to="{ name: $route.name, params: {user_story_doc_id: stage.scrum_user_story_doc_id, 'project_id': project.id, 'sprint_id': sprint.id }}">
                            <p>{{sprint.title}}</p>
                            <div class="row g-0 sprint-meta">
                                <div class="col">
                                    <span class="muted">Start:</span> {{sprint.start_date | moment('DD/MM/YYYY')}}
                                </div>
                                <div class="col">
                                    <span class="muted">End:</span> {{sprint.end_date | moment('DD/MM/YYYY')}}
                                </div>
                                <div class="col text-end">
                                    <span class="status" v-bind:class="statusClassForSprint(sprint)">{{sprint.status}}</span>
                                </div>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    props: {
        project: {
            type: Object
        },
        stage: {
            type: Object
        },
        sprint: {
            type: Object
        },
        sprints: {
            type: Array
        }
    },
    computed: {
        statusClass() {
            return this.statusClassForSprint(this.sprint)
        }
    },

    methods: {
      statusClassForSprint(sprint) {
        switch(sprint.status) {
            case "Complete":
                return {primary: true}
                break
            case "Scheduled":
                return {info: true}
                break
            case "Active":
                return {success: true}
                break
        }
      }
    }
}
</script>
